import React, { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { createAuth, getAuth } from '../features/auth/authSlice';
import { toast } from 'react-toastify';
import { createFormData } from '../utils/commonHelper';

const AuthModal = ({ modalIsOpen, setModalIsOpen }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { fromCheckout } = location.state || {};
    const [activeForm, setActiveForm] = useState(true); //true=>login false=>signup
    const [registrationFormData, setRegistrationFormData] = useState({ name: "", email: "", password: "", role: "user" });
    const [logInFormData, setLogInFormData] = useState({ email: "user@yopmail.com", password: "Test@123" });
    const { login } = useAuth();


    const { user, status, message } = useSelector(state => state.auth);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (activeForm) {
            setLogInFormData({
                ...logInFormData,
                [name]: value,
            });
        } else {
            setRegistrationFormData({
                ...registrationFormData,
                [name]: value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (activeForm) {
            const data = createFormData(logInFormData);
            dispatch(getAuth(data));
        } else {
            const data = createFormData(registrationFormData);
            dispatch(createAuth(data));
        }
    }

    useEffect(() => {
        if (status) {
            login(user);
            if (fromCheckout) {
                navigate(`/checkout`);
            } else {

                navigate(`/`);
            }
            toast.success(message);
            setModalIsOpen(false)
        }
        // // console.log("fromCheckout :: ", fromCheckout);
    }, [status, user, login, navigate, message, fromCheckout, setModalIsOpen])

    return (
        <Modal
            size="md"
            show={modalIsOpen}
            onHide={() => setModalIsOpen(false)}
            className='login-modal'
            centered={true}
            style={{
                overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
                content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)" }
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title >
                    {activeForm ? t('auth.logInTitle') : t('auth.signUpTitle')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {!activeForm ? (
                    <form className="signup-form">
                        <Row>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="name">{t('auth.name')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auth.name')}
                                        name="name"
                                        id="name"
                                        className='element-style'
                                        value={registrationFormData?.name || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="email">{t('auth.email')}</label>
                                    <Form.Control
                                        type="email"
                                        placeholder={t('auth.email')}
                                        name="email"
                                        id="email"
                                        className='element-style'
                                        value={registrationFormData?.email || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="password">{t('auth.password')}</label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('auth.password')}
                                        name="password"
                                        id="password"
                                        className='element-style'
                                        value={registrationFormData?.password || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="confirm_password">{t('auth.confirmPassword')}</label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('auth.confirmPassword')}
                                        name="confirm_password"
                                        id="confirm_password"
                                        className='element-style'
                                        value={registrationFormData?.confirm_password || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col sm={5}>
                                <div className="form-group">
                                    <button className="btn h-btn" type="submit" onClick={handleSubmit}>
                                        {t('auth.signUp')}
                                    </button>
                                </div>
                            </Col>
                            <Col sm={7}>
                                <p className='option-text'>
                                    {t('auth.alreadyHaveAnAccount')}
                                    <button type="button" className="btn-link" onClick={() => setActiveForm(!activeForm)} >
                                        {t('auth.signIn')}
                                    </button>
                                </p>
                            </Col>
                        </Row>
                    </form>
                ) : (
                    <form className="signin-form">
                        <Row>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="email">{t('auth.email')}</label>
                                    <Form.Control
                                        type="email"
                                        placeholder={t('auth.email')}
                                        name="email"
                                        id="email"
                                        className='element-style'
                                        value={logInFormData?.email || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label htmlFor="password">{t('auth.password')}</label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('auth.password')}
                                        name="password"
                                        id="password"
                                        className='element-style'
                                        value={logInFormData?.password || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Col>
                            <Col sm={5}>
                                <div className="form-group">
                                    <button className="btn h-btn" type="submit" onClick={handleSubmit}>
                                        {t('auth.signIn')}
                                    </button>
                                </div>
                            </Col>
                            <Col sm={7}>
                                <p className='option-text'>
                                    {t('auth.needAnAccount')}
                                    <button type="button" className="btn-link" onClick={() => setActiveForm(!activeForm)}>
                                        {t('auth.signUp')}
                                    </button>
                                </p>
                            </Col>
                        </Row>
                    </form>
                )}
            </Modal.Body>
        </Modal >

    )
}

export default AuthModal;
